export default __webpack_public_path__ + "static/media/timer-sound.49bf0503.mp3";